import loadable from '@loadable/component';

// Template
import PublicTemplate from '../../components/public/PublicTemplate';

const publicRoutes = {
  name: 'public.root',
  path: '/',
  component: PublicTemplate,
  query: require('../../components/public/__generated__/PublicTemplateQuery.graphql'),
  routes: [
    {
      name: 'public',
      path: '/',
      component: loadable(() => import('../../components/home/Home')),
      exact: true,
      query: require('../../components/home/__generated__/HomeQuery.graphql'),
      queriesParams: () => ({ first: 100, isPublicInternet: true }),
    },
    {
      name: 'public.home',
      path: '/home',
      component: loadable(() => import('../../components/home/Home')),
      exact: true,
      query: require('../../components/home/__generated__/HomeQuery.graphql'),
      queriesParams: () => ({ first: 100, isPublicInternet: true }),
    },
    {
      name: 'public.vacancies',
      path: '/vaga/:id',
      component: loadable(() => import('../../components/jobs/JobPost')),
      exact: true,
      query: require('../../components/jobs/__generated__/JobPostQuery.graphql'),
      queriesParams: ({ match: { params } }) => ({ id: params.id }),
    },
    {
      name: 'public.search',
      path: '/busca/:search?',
      component: loadable(() => import('../../components/jobs/Search')),
      exact: true,
      query: require('../../components/jobs/__generated__/SearchQuery.graphql'),
      queriesParams: ({ match: { params } }) => ({
        search: params.search || '',
        first: 100,
      }),
    },
    {
      name: 'public.notFound',
      path: '/notFound',
      component: loadable(() => import('../../components/public/NotFound')),
      exact: true,
    },
  ],
};

export default publicRoutes;
